export interface Environment {
  production: boolean;
  apiUrl: string;
  settingsUrl: string;
  aiApiRoot: string;
}

/**
 * Get environment variable from Vite's import.meta.env
 */
const getEnvVar = (key: string, defaultValue = ''): string => {
  const value = import.meta.env[key] ?? defaultValue;
  return typeof value === 'string' ? value.trim() : defaultValue;
};

/**
 * Check if running in production mode
 */
const isProduction = (): boolean => {
  return import.meta.env.MODE === 'production';
};

/**
 * Environment configuration
 * Automatically uses production or development config based on build mode
 */
export const environment: Environment = {
  production: isProduction(),
  apiUrl: isProduction()
    ? getEnvVar('VITE_API_URL', '/')
    : getEnvVar('VITE_API_URL', 'http://localhost:8080/'),
  settingsUrl: isProduction()
    ? getEnvVar('VITE_SETTINGS_URL', '/api/settings')
    : getEnvVar('VITE_SETTINGS_URL', 'http://localhost:8080/settings'),
  aiApiRoot: isProduction()
    ? getEnvVar('VITE_AI_API_ROOT', '/api/aiApiRoot')
    : getEnvVar('VITE_AI_API_ROOT', 'http://localhost:8080/aiApiRoot'),
};
